exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-heading-units{display:inline-flex}.csv-symbol-units{margin-right:8px}\n", ""]);

// exports
